// Standard ISO-8601 week/year calculation (Monday-start weeks, week 1 = the
// week containing the year's first Thursday). No external file or API call.
export function getIsoWeek(date = new Date()) {
  const d = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
  const dayNum = (d.getUTCDay() + 6) % 7; // Mon=0 .. Sun=6
  d.setUTCDate(d.getUTCDate() - dayNum + 3); // shift to nearest Thursday

  const isoYear = d.getUTCFullYear();
  const firstThursday = new Date(Date.UTC(isoYear, 0, 4));
  const firstDayNum = (firstThursday.getUTCDay() + 6) % 7;
  firstThursday.setUTCDate(firstThursday.getUTCDate() - firstDayNum + 3);

  const week = 1 + Math.round((d - firstThursday) / (7 * 24 * 3600 * 1000));
  return { week, year: isoYear };
}

export function formatIsoWeek(date = new Date()) {
  const { week, year } = getIsoWeek(date);
  return `ISO W${String(week).padStart(2, "0")}, ${year}`;
}
